import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { DatePipe } from '@angular/common';
import { RMDashboardService } from '../../services/rm-dashboard.service';
import { Options } from 'highcharts';
import Drilldown from 'highcharts/modules/drilldown';
import More from 'highcharts/highcharts-more';
import Exporting from 'highcharts/modules/exporting';
import { TechnicianService } from 'src/app/services/technician.service';
import { ManagerExecutionService } from 'src/app/services/manager.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { RMconfigurationService } from 'src/app/services/rmconfiguration.service';
import * as _ from 'lodash';
import { pmDasboardbtnRenderer } from 'src/app/PM-Dashboard-btn-renderer.component';
import { environment } from 'src/environments/environment';
import { UserConfigurationsService } from 'src/app/services/user-configurations.service';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { prevTaskService } from 'src/app/services/prev-task.service';

More(Highcharts);
Drilldown(Highcharts);
Exporting(Highcharts);

@Component({
  selector: 'app-pm-dashboard',
  templateUrl: './pm-dashboard.component.html',
  styleUrls: ['./pm-dashboard.component.scss'],
})
export class PmDashboardComponent implements OnInit {
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('popupViewModal') private popupViewModal!: TemplateRef<any>;
  @ViewChild('breakDownDialog') private breakDownDialog!: TemplateRef<any>;
  @ViewChild('PMadherance') private PMadherance!: TemplateRef<any>;
  @ViewChild('checklistHistory') private checklistHistory!: TemplateRef<any>;
  @ViewChild('parameterHistory') private parameterHistory!: TemplateRef<any>;
  @ViewChild('SubtaskHistory') private SubtaskHistory!: TemplateRef<any>;
  @ViewChild('WorkLogDetails') private WorkLogDetails!: TemplateRef<any>;
  @ViewChild('previewModal') private previewModal!: TemplateRef<any>;
  @ViewChild('viewdocument') private viewdocument!: TemplateRef<any>;
  @ViewChild('TaskCompletedDialog')
  private TaskCompletedDialog!: TemplateRef<any>;
  private dialogRef: MatDialogRef<any> | null = null;
  @ViewChild('TaskNotCompletedDialog')
  private TaskNotCompletedDialog!: TemplateRef<any>;
  @ViewChild('allSelectedLine') private allSelectedLine: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  // startDate = new FormControl(moment());
  // endDate = new FormControl(moment());

  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any;
  filteredUnits: any;
  filteredComponents: any;
  // IsAccess: any;
  // IsWrite: any;
  GroupList!: any[];
  PlantList!: any[];
  LineList!: any[];
  UnitList!: any[];
  componentList!: any;
  permisson!: any;
  CLLDashboardForm!: FormGroup;
  TotalDefects!: any;
  TotalDefecteSolved!: any;
  CILAdherence!: any;
  TotalDefectsPerc!: any;
  CILTask!: any;
  key: any;
  doc: any;
  Id: any;
  dashboardData!: any;
  chartCILTask!: Chart;
  chartCILType!: Chart;
  chartCILTool!: Chart;
  highCharts: any;
  image!: any;
  currentImagePath!: any;
  defaultExcelExportParams: any;

  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;

  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  unitPickerIsOpen: boolean = false;
  isPickFromUnit: boolean = false;
  HeaderData: any = {
    Group: '',
    // displayMachine: '',
    StartDate: new Date(
      moment().subtract(1, 'd').set('hour', 6).set('minutes', 0).toString()
    ),
    EndDate: new Date(),
    Plant: '',
    Line: '',
  };
  HeaderForm: any;
  TotalWO: any = 0;
  ClosedWO: any = 0;
  CompletedWO: any = 0;
  OpenedWO: any = 0;
  MTTRDays: any = 0;
  MTTRHours: any = 0;
  MTTRMinutes: any = 0;
  MTBFDays: any = 0;
  MTBFHours: any = 0;
  MTBFMinutes: any = 0;
  UsedSpareParts: any = 0;
  TreeData: any = [];

  Minor: any = 0;
  Moderate: any = 0;
  Major: any = 0;
  ResponseTime: any = 0;
  TroubleShootTime: any = 0;
  WaitingSPTime: any = 0;
  MDTTime: any = 0;
  UnitsInGroup: any = [];
  PlantsInGroup: any = [];
  UnitsByLine: any = [];
  ComponentByUnit: any = [];

  chartMachine!: Chart;
  chartComponent!: Chart;
  isGreenMark!: boolean;
  selectedDate = 'Today';
  filteredDate: any[];
  drilldownData: any;
  spinnerText: string = '';
  userList: any = [];
  ChartName: any;
  isGreenOpenMark!: boolean;
  isGreenCompleteMark!: boolean;
  isGreenCloseMark!: boolean;
  openedPercentage: any;
  completedPercentage: any;
  closedPercentage: any;
  minorArr: any = [];
  moderateArr: any = [];
  majorArr: any = [];
  images: any[] = [];
  viewDocument: SafeUrl = '';
  fileType!: string;
  chartMinor!: Chart;
  chartModerate!: Chart;
  chartMajor!: Chart;
  technicianTaskId: number;
  isMinorChart: boolean = false;
  isModerateChart: boolean = false;
  isMajorChart: boolean = false;
  displayMaximizable = false;
  options: Options;
  totalBreakdowns: any;
  imageIndexOne = 0;
  bdCategory: any;
  majorBDMachineLevel: any;
  majorBDSubAssemblyLevel: any;
  previewerData!: MatTableDataSource<any>;
  previewerColumns: string[] = ['Desc', 'Action', 'View'];
  months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  dashboardCount: any = {
    completed: 0,
    notCompleted: 0,
    tbm: 0,
    adhernce: 0,
  };
  taskType: any = [];
  workLogs: any[] = [];
  completedAdherence: any = [];
  notCompletedAdherence: any = [];
  previewArray: {
    technicianTaskId: number;
    fileName: string;
    filePath: string;
  }[] = [];
  chartTaskCompletedUnit: Chart;
  chartTaskCompletedFrequency: Chart;
  chartTaskCompletedTaskType: Chart;
  chartTaskCompletedMaintenanceType: Chart;

  chartTaskNotCompletedUnit: Chart;
  chartTaskNotCompletedFrequency: Chart;
  chartTaskNotCompletedTaskType: Chart;
  chartTaskNotCompletedMaintenanceType: Chart;

  TaskCompletedChartData: any = {
    AllData: [],
    UnitData: [],
    FrequencyData: [],
    TaskTypeData: [],
    MaintenanceTypeData: [],
  };

  TaskNotCompletedChartData: any = {
    AllData: [],
    UnitData: [],
    FrequencyData: [],
    TaskTypeData: [],
    MaintenanceTypeData: [],
  };

  frameworkComponents: any;
  rowData!: any[];
  columnDefs!: any[];
  subtaskcolumnDefs!: any[];
  workLogcolumnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- HERE
      // minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
    },
    popupParent: document.querySelector('body'),
  };
  domLayout = 'autoHeight';
  lang: any;
  isAccess = ApplicationPermission.PM_DASHBOARD_ACCESS;
  isWrite = ApplicationPermission.PM_DASHBOARD_CREATE;
  isUpdate = ApplicationPermission.PM_DASHBOARD_UPDATE;
  isDelete = ApplicationPermission.PM_DASHBOARD_DELETE;
  plantSession: any;
  groupSession: any;
  userSession: any;
  checklistColumnDefs: any[] = [];
  autoGroupColumnDef: any;
  checklistrowData: any[] = [];
  parameterolumnDefs: any[] = [];
  ButtonType: string;
  parameterrowData: any[] = [];
  subTaskData: any[] = [];
  blobUrl: string = environment.blobStorageUrl;
  tabs: any[] = [];

  constructor(
    private userConfigService: UserConfigurationsService,
    public translater: TranslaterService,
    public translate: TranslateService,
    private toaster: ToastrService,
    public router: Router,
    private technicianService: TechnicianService,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private pmDashboardService: RMDashboardService,
    private fb: FormBuilder,
    private baseApi: BaseApi,
    public managerExecutionService: ManagerExecutionService,
    private dialog: MatDialog,
    private rmconfigurationService: RMconfigurationService,
    private employeeService: EmployeeService,
    private PrevConfigurationService: PrevConfigurationService,
    private sanitizer: DomSanitizer,
    private prevTaskService: prevTaskService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      event.lang === 'ar'
        ? (this.languageDir = 'rtl')
        : (this.languageDir = 'ltr');
      this.getLangWords();
    });
    this.filteredDate = [
      { value: 'Today' },
      { value: 'Yesterday' },
      { value: 'Last Week' },
      { value: 'Last Month' },
    ];

    this.defaultExcelExportParams = {
      addImageToCell: function (
        rowIndex: number,
        col: any,
        value: any,
        callback: any
      ) {
        if (col.colId === 'PreImage' || col.colId === 'PostImage') {
        } else {
          return;
        }
      },
    };

    this.subtaskcolumnDefs = [
      {
        headerName: 'Work Order ID',
        field: 'subtaskId',
        filter: 'agSetColumnFilter',
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      { headerName: 'WO Details', field: 'Detail' },
      {
        headerName: 'Responsible',
        field: 'ResponsibleName',
        width: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'External Vendor',
        field: 'ExternalVendor',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Status',
        field: 'Status',
        headerValueGetter: this.localizeHeader.bind(this),
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          values: ['Pending', 'Completed'],
        },
      },
      {
        headerName: 'Target Date',
        field: 'TargetDate',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateOnly') : null,
      },
      {
        headerName: 'Completion Date',
        field: 'CompletionDate',
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: (params: any) =>
          params.value ? this.formatCellData(params.value, 'dateTime') : null,
      },
    ];

    this.workLogcolumnDefs = [
      {
        headerName: 'Title',
        field: 'title',
        filter: 'agSetColumnFilter',
        // headerValueGetter: this.localizeHeader.bind(this),
        flex: 1,
      },
    ];

    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: { clicked: (field: any) => { } },
        maxWidth: 200,
        minWidth: 50,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Task Description',
        field: 'Description',
        minWidth: 150,
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Line',
        field: 'Line',
        minWidth: 100,
        filter: 'agSetColumnFilter',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Unit',
        field: 'Unit',
        minWidth: 100,
        filter: 'agSetColumnFilter',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Assembly',
        field: 'Assembly',
        filter: 'agSetColumnFilter',
        minWidth: 100,
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'SubAssembly',
        field: 'SubAssembly',
        filter: 'agSetColumnFilter',
        minWidth: 100,
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Component',
        field: 'Component',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params && params.value ? params.value : '';
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Frequency',
        field: 'FrequencyName',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        cellRenderer: function (params: any) {
          let html = params.value;
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Task Type',
        field: 'TaskTypeName',
        minWidth: 150,
        filter: 'agSetColumnFilter',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params.value;
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Activity Type',
        field: 'Activitytype',
        filter: 'agSetColumnFilter',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params.value;
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Activity Type',
        field: 'Activitytype',
        filter: 'agSetColumnFilter',
        wrapText: true,
        cellRenderer: function (params: any) {
          let html = params.value;
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      // {
      //   headerName: 'Technician',
      //   field: 'TaskBy',
      //   filter: 'agSetColumnFilter',
      //   wrapText: true,
      //   cellRenderer: (params: any) => {
      //     const employeeCode = params.value;
      //     const user = this.userList?.find(u => u.employeeCode === employeeCode);
      //     return user ? user.fullName : employeeCode;
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this),
      // },
      {
        headerName: 'Technician',
        field: 'Technician',
        minWidth: 150,
        filter: 'agSetColumnFilter',
        cellRenderer: function (params: any) {
          let html = params.value;
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Attachment',
        minWidth: 90,
        field: 'UploadFile',
        sortable: true,
        filter: true,
        cellRenderer: function (params: any) {
          return `
            <button style="background: none; border: none; cursor: pointer;margin-top:7px;">
              <i class="material-icons" style="color: #B95CF4; font-size: 24px;">visibility</i>
            </button>`;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Maintenance Type',
        field: 'MaintenanceType',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        valueFormatter: function (params: any) {
          let html = params.value;
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Start Time',
        field: 'StartTime',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        wrapText: true,
        headerValueGetter: this.localizeHeader.bind(this),
        // cellRenderer: function (params: any) {
        //   let html =
        //     params && params.value
        //       ? moment(params.value).format('DD/MM/YYYY hh:mm a')
        //       : '';
        //   return html;
        //  },
      },
      {
        headerName: 'Finish Time',
        field: 'FinishTime',
        minWidth: 150,
        filter: 'agSetColumnFilter',
        wrapText: true,
        headerValueGetter: this.localizeHeader.bind(this),
        // cellRenderer: function (params: any) {
        //   let html =
        //     params && params.value
        //       ? moment(params.value).format('DD/MM/YYYY hh:mm a')
        //       : '';
        //   return html;
        //  },
      },
      {
        headerName: 'Status',
        field: 'displayStatus',
        minWidth: 150,
        filter: 'agSetColumnFilter',
        cellStyle: function (params: any) {
          if (params.value == 'Done')
            return { color: 'white', backgroundColor: 'green' };
          else return { color: 'white', backgroundColor: 'red' };
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Item Code',
        field: 'ItemCode',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Item Name',
        field: 'ItemName',
        minWidth: 150,
        filter: 'agSetColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Item Desc',
        field: 'ItemDesc',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'Spare Parts Used',
        field: 'SparePartsUsed',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'ParameterCount',
        field: 'ParameterCount',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'ParameterNames',
        field: 'ParameterNames',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'ChecklistCount',
        field: 'ChecklistCount',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        headerName: 'ChecklistNames',
        field: 'ChecklistNames',
        filter: 'agSetColumnFilter',
        minWidth: 150,
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];

    this.checklistColumnDefs = [
      {
        field: 'itemGroup',
        rowGroup: true,
        hide: true,
      },
      { field: 'itemName', headerName: 'Item Name' },
      { field: 'standard', headerName: 'Standard' },
      { field: 'minValue', headerName: 'Min Value' },
      { field: 'maxValue', headerName: 'Max Value' },
      {
        headerName: 'Good Example',
        field: 'goodExampleImage',
        cellRenderer: (params: any) =>
          params.value
            ? `<img src="${params.value}" style="width: 40px; height: 40px;" />`
            : '',
      },
      {
        headerName: 'Bad Example',
        field: 'badExampleImage',
        cellRenderer: (params: any) =>
          params.value
            ? `<img src="${params.value}" style="width: 40px; height: 40px;" />`
            : '',
      },
      {
        headerName: 'Result',
        field: 'catType',
        cellRenderer: (params: any) => {
          const itemType = params.data?.itemType;
          const catType = params.value;
          if (!catType || catType === 'null') {
            return '';
          }

          if (itemType === 3) {
            return moment(catType).format('DD/MM/YYYY');
          }

          if (itemType === 4) {
            const baseUrl = this.blobUrl;
            return `
              <button mat-mini-fab color="warn" title="View Files" ptooltip="Action History" tooltipposition="top" 
                      class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary" 
                      style="background-color: #7a1dcf;" ng-reflect-color="primary" ng-reflect-text="Action Detail" ng-reflect-tooltip-position="top" 
                      >
                <span class="mat-button-wrapper">
                  <i class="fa fa-eye" style="color: #fff;"></i>
                </span>
                <span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
                <span class="mat-button-focus-overlay"></span>
              </button>`;
          }

          return catType;
        },
      },
      {
        field: 'remarks',
        headerName: 'Remarks',
      },

      // {
      //   field: 'Item',
      //   headerName: 'Items',
      //   resizable: true,
      //   sortable: true,
      //   wrapText: true,
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      // {
      //   field: 'ItemType',
      //   headerName: 'Item Type',
      //   resizable: true,
      //   sortable: true,
      //   hide: true,
      //   wrapText: true,
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      // {
      //   field: 'Standard',
      //   headerName: 'Standard',
      //   resizable: true,
      //   sortable: true,
      //   hide: true,
      //   wrapText: true,
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      // {
      //   field: 'Min',
      //   headerName: 'Min',
      //   resizable: true,
      //   sortable: true,
      //   wrapText: true,
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      // {
      //   field: 'Max',
      //   headerName: 'Max',
      //   resizable: true,
      //   sortable: true,
      //   wrapText: true,
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      // {
      //   field: 'GoodExampleImageName',
      //   headerName: 'Good Example',
      //   resizable: true,
      //   headerValueGetter: this.localizeHeader.bind(this),
      //   cellRenderer: (params: any): any => {
      //     if (params.value) {
      //       return `<button mat-mini-fab="" color="warn" title="View Files" ptooltip="Action History" tooltipposition="top" class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary" style="background-color: #7a1dcf;" ng-reflect-color="primary" ng-reflect-text="Action Detail" ng-reflect-tooltip-position="top"><span class="mat-button-wrapper"><i class="fa fa-eye" style="color: #fff;"></i></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>`;
      //     }
      //   },
      // },
      // {
      //   field: 'BadExampleImageName',
      //   headerName: 'Bad Example',
      //   resizable: true,
      //   cellRenderer: (params: any): any => {
      //     if (params.value) {
      //       return `<button mat-mini-fab="" color="warn" title="View Files" ptooltip="Action History" tooltipposition="top" class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary" style="background-color: #7a1dcf;" ng-reflect-color="primary" ng-reflect-text="Action Detail" ng-reflect-tooltip-position="top"><span class="mat-button-wrapper"><i class="fa fa-eye" style="color: #fff;"></i></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>`;
      //     }
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      // {
      //   field: 'Execution_Result',
      //   headerName: 'Result',
      //   resizable: true,
      //   sortable: true,
      //   wrapText: true,
      //   cellRenderer: (params: any) => {
      //     const itemType = params.data?.ItemType;
      //     const value = params.value;

      //     if (!value || value === 'null') {
      //       return '';
      //     }

      //     if (itemType === 5) {
      //       const dropdown = params.data?.Execution_DropDownValue;
      //       return dropdown;
      //     }

      //     if (itemType === 3) {
      //       const date = new Date(value);
      //       return this.formatCellData(params.value, 'dateTime');
      //     }

      //     if (itemType === 4) {
      //       // If ItemType is 4, show View Files button instead of image
      //       const baseUrl = this.blobUrl;
      //       return `
      //         <button mat-mini-fab color="warn" title="View Files" ptooltip="Action History" tooltipposition="top"
      //                 class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary"
      //                 style="background-color: #7a1dcf;" ng-reflect-color="primary" ng-reflect-text="Action Detail" ng-reflect-tooltip-position="top"
      //                 >
      //           <span class="mat-button-wrapper">
      //             <i class="fa fa-eye" style="color: #fff;"></i>
      //           </span>
      //           <span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
      //           <span class="mat-button-focus-overlay"></span>
      //         </button>`;
      //     }

      //     return value;
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      // {
      //   field: 'Execution_Remark',
      //   headerName: 'Remark',
      //   resizable: true,
      //   sortable: true,
      //   wrapText: true,
      //   valueFormatter: (params) => {
      //     return (params.value === null || params.value === 'null' || params.value === undefined) ? '' : params.value;
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this)

      // },
      // {
      //   field: 'Execution_CreatedAt',
      //   headerName: 'Created On',
      //   valueFormatter: (params) => {
      //     const date = new Date(params.value);
      //     return this.formatCellData(params.value, 'dateTime');;
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this)

      // },
      // {
      //   field: 'CreatedBy',
      //   headerName: 'Created By',
      //   headerValueGetter: this.localizeHeader.bind(this)
      // }
    ];

    this.parameterolumnDefs = [
      {
        field: 'ParameterName',
        headerName: 'Parameter',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        field: 'Target',
        headerName: 'Target',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        field: 'TrigerAtValue',
        headerName: 'Trigger At',
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        field: 'ResultOnDate',
        headerName: 'Result On Date',
        valueFormatter: (params: any) => {
          if (!params.value) return '';
          return new Date(params.value).toLocaleDateString();
        },
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        field: 'Actual',
        headerName: 'Actual',
        headerValueGetter: this.localizeHeader.bind(this),
      },
    ];
    valueFormatter: (params: any) => {
      if (!params.value) return '';
      const date = new Date(params.value);
      return `${date.getDate().toString().padStart(2, '0')}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}-${date.getFullYear()}`;
    };

    this.autoGroupColumnDef = {
      headerName: 'Item Group',
    };

    this.frameworkComponents = {
      buttonRenderer: pmDasboardbtnRenderer,
    };
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.userSession = this.baseApi.getUserSession();
    this.getLangWords();
    this.HeaderForm = this.fb.group({
      StartDate: ['', Validators.required],
      EndDate: ['', Validators.required],
      Line: ['', Validators.required],
    });
    this.getLine();
    this.getUserList();
  }

  defaultColDef = {
    flex: 1,
    resizable: true,
    sortable: true,
    filter: true,
  };

  autoGroupColumnDefPMQC = {
    headerName: 'Area Name',
    field: 'areaName',
    cellRendererParams: {
      suppressCount: false,
    },
  };

  getUserList() {
    this.spinnerText = 'Fetching User Data';
    this.spinner.show();
    this.employeeService.getAllEmployees().subscribe(
      (res: any) => {
        this.userList = res;
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
      }
    );
  }

  formatCellData(value: any, formatType: string): string {
    return this.userConfigService.formatField(value, formatType);
  }

  openModal() {
    this.unitPickerIsOpen = true;
    this.isPickFromUnit = true;
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find((x) => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:
        this.translate.currentLang === 'en'
          ? 1
          : this.translate.currentLang === 'ar'
            ? 2
            : this.translate.currentLang === 'fr'
              ? 3
              : this.translate.currentLang === 'sp'
                ? 4
                : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  getLine() {
    const key = {
      PlantCode: this.plantSession?.plantCode,
      userCode: this.userSession?.userCode,
    };
    this.spinner.show();
    this.rmconfigurationService.getLineData(key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.LineList = data.lstLine;
        this.filteredLines = this.LineList.slice();

        if (this.LineList && this.LineList.length) {
          const allLines = this.filteredLines.map((x) => x.PL_Id);
          this.HeaderForm.controls?.line?.patchValue(['ALL', ...allLines]);
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  udpateNodeParentDetails() {
    if (this.TreeData && this.TreeData.length) {
      this.TreeData.forEach((group: any) => {
        if (group.children && group.children.length) {
          group.children.forEach((plant: any) => {
            plant.groupName = group.text;
            plant.groupId = group.PrimaryId;
            if (plant.children && plant.children.length) {
              plant.children.forEach((division: any) => {
                division.plantId = plant.PrimaryId;
                division.plantName = plant.text;
                division.groupName = group.text;
                division.groupId = group.PrimaryId;
                if (division.children && division.children.length) {
                  division.children.forEach((department: any) => {
                    department.divisionId = division.PrimaryId;
                    department.divisionName = division.text;
                    department.plantId = plant.PrimaryId;
                    department.plantName = plant.text;
                    department.groupId = group.PrimaryId;
                    department.groupName = group.text;
                    if (department.children && department.children.length) {
                      department.children.forEach((line: any) => {
                        line.departmentId = department.PrimaryId;
                        line.departmentName = department.text;
                        line.divisionId = division.PrimaryId;
                        line.divisionName = division.text;
                        line.plantId = plant.PrimaryId;
                        line.plantName = plant.text;
                        line.groupId = group.PrimaryId;
                        line.groupName = group.text;
                        if (line.children && line.children.length) {
                          line.children.forEach((unit: any) => {
                            unit.lineId = line.PrimaryId;
                            unit.lineName = line.text;
                            unit.departmentId = department.PrimaryId;
                            unit.departmentName = department.text;
                            unit.divisionId = division.PrimaryId;
                            unit.divisionName = division.text;
                            unit.plantId = plant.PrimaryId;
                            unit.plantName = plant.text;
                            unit.groupId = group.PrimaryId;
                            unit.groupName = group.text;
                            if (unit.children && unit.children.length) {
                              unit.children.forEach((assembly: any) => {
                                assembly.unitName = unit.text;
                                assembly.unitId = unit.PrimaryId;
                                assembly.lineId = line.PrimaryId;
                                assembly.lineName = line.text;
                                assembly.departmentId = department.PrimaryId;
                                assembly.departmentName = department.text;
                                assembly.divisionId = division.PrimaryId;
                                assembly.divisionName = division.text;
                                assembly.plantId = plant.PrimaryId;
                                assembly.plantName = plant.text;
                                assembly.groupId = group.PrimaryId;
                                assembly.groupName = group.text;
                                if (
                                  assembly.children &&
                                  assembly.children.length
                                ) {
                                  assembly.children.forEach(
                                    (subAssembly: any) => {
                                      subAssembly.assemblyName = assembly.text;
                                      subAssembly.assemblyId =
                                        assembly.PrimaryId;
                                      subAssembly.unitName = unit.text;
                                      subAssembly.unitId = unit.PrimaryId;
                                      subAssembly.lineId = line.PrimaryId;
                                      subAssembly.lineName = line.text;
                                      subAssembly.departmentId =
                                        department.PrimaryId;
                                      subAssembly.departmentName =
                                        department.text;
                                      subAssembly.divisionId =
                                        division.PrimaryId;
                                      subAssembly.divisionName = division.text;
                                      subAssembly.plantId = plant.PrimaryId;
                                      subAssembly.plantName = plant.text;
                                      subAssembly.groupId = group.PrimaryId;
                                      subAssembly.groupName = group.text;
                                      if (
                                        subAssembly.children &&
                                        subAssembly.children.length
                                      ) {
                                        subAssembly.children.forEach(
                                          (component: any) => {
                                            component.subAssemblyName =
                                              subAssembly.text;
                                            component.subAssemblyId =
                                              subAssembly.PrimaryId;
                                            component.assemblyName =
                                              assembly.text;
                                            component.assemblyId =
                                              assembly.PrimaryId;
                                            component.unitName = unit.text;
                                            component.unitId = unit.PrimaryId;
                                            component.lineId = line.PrimaryId;
                                            component.lineName = line.text;
                                            component.departmentId =
                                              department.PrimaryId;
                                            component.departmentName =
                                              department.text;
                                            component.divisionId =
                                              division.PrimaryId;
                                            component.divisionName =
                                              division.text;
                                            component.plantId = plant.PrimaryId;
                                            component.plantName = plant.text;
                                            component.groupId = group.PrimaryId;
                                            component.groupName = group.text;
                                          }
                                        );
                                      }
                                    }
                                  );
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  }
  autoSizeAllColumns() {
    this.gridApi.setRowData(this.dashboardData);
    this.gridColumnApi.autoSizeAllColumns();
  }
  getRMDashboard() {
    if (
      !this.groupSession.groupCode ||
      !this.HeaderData.Line ||
      !this.plantSession.plantCode ||
      !this.HeaderData.StartDate ||
      !this.HeaderData.EndDate
    )
      return;
    this.spinner.show();
    const plIdValue = this.HeaderForm.get('Line')?.value.toString();
    const plIdArray = plIdValue.split(',');
    const filteredPlIdArray = plIdArray.filter(
      (value) => value.trim() !== 'ALL'
    );
    const filteredLineValue = filteredPlIdArray.join(',');
    const data = {
      Groupcode: this.groupSession?.groupCode,
      PLID: filteredLineValue,
      Plantcode: this.plantSession?.plantCode,
      PUID: this.HeaderData.ChartUnit,
      dateStart: this.HeaderData.StartDate,
      dateEnd: this.HeaderData.EndDate,
    };
    this.pmDashboardService.getPMTaskDetailsDash(data).subscribe(
      (res: any) => {
        this.dashboardData = res;
        const blobStorageUrl = environment.blobStorageUrl;
        this.autoSizeAllColumns();
        this.dashboardCount.completed = 0;
        this.dashboardCount.notCompleted = 0;
        this.dashboardCount.tbm = 0;
        this.dashboardCount.adhernce = 0;
        this.taskType = [];
        this.completedAdherence = [];
        this.notCompletedAdherence = [];

        const monthName = (item) =>
          moment(item.TaskExpireTime, 'YYYY-MM-DD').format('MMM');
        const result = _.groupBy(this.dashboardData, monthName);
        this.completedAdherence = Array(12).fill(0);
        this.notCompletedAdherence = Array(12).fill(0);
        this.months.forEach((month, index) => {
          if (result[month] && result[month].length) {
            const completedItems = result[month].filter(
              (item) => item.Status === 1
            );
            const notCompletedItems = result[month].filter(
              (item) => item.Status === 0
            );

            const completedPercentage = (
              (completedItems.length / result[month].length) *
              100
            ).toFixed(2);
            const notCompletedPercentage = (
              (notCompletedItems.length / result[month].length) *
              100
            ).toFixed(2);

            this.completedAdherence[index] = Number(completedPercentage);
            this.notCompletedAdherence[index] = Number(notCompletedPercentage);
          }
        });
        this.dashboardData.map((val) => {
          if (val.Status == 1) {
            this.dashboardCount.completed += 1;
            val.displayStatus = 'Done';
          } else if (val.Status == 0) {
            this.dashboardCount.notCompleted += 1;
            val.displayStatus = 'Not Done';
          }
          if (val.MaintenanceType === 'Time Based')
            this.dashboardCount.tbm += 1;
          if (!this.taskType.some((task) => task.name == val.TaskTypeName)) {
            const data = {
              name: val.TaskTypeName,
              count: this.dashboardData.filter(
                (rec) => rec.TaskTypeName == val.TaskTypeName
              ).length,
            };
            this.taskType.push(data);
          }
          if (val.StartTime)
            val.StartTime = val.StartTime
              ? moment(val.StartTime).format('DD/MM/YYYY hh:mm a')
              : '';
          if (val.FinishTime)
            val.FinishTime = val.FinishTime
              ? moment(val.FinishTime).format('DD/MM/YYYY hh:mm a')
              : '';
          // Extract and process UploadFile string
          if (val.UploadFile && typeof val.UploadFile === 'string') {
            const filePaths = val.UploadFile.split(',').map((f) => f.trim());
            filePaths.forEach((path) => {
              if (path) {
                const fileName = path.split('/').pop() || 'Unnamed';
                const fullPath = `${blobStorageUrl}${path}`;
                this.previewArray.push({
                  technicianTaskId: val.TechnicianTaskId, // save TaskID
                  fileName,
                  filePath: fullPath,
                });
              }
            });
          }
        });
        this.dashboardCount.adhernce = (
          (this.dashboardCount.completed / this.dashboardData.length) *
          100
        ).toFixed(2);
        this.dashboardCount.adhernce =
          this.dashboardCount.adhernce == 'NaN'
            ? '0'
            : this.dashboardCount.adhernce;
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    );
    // }
  }

  setData() { }

  leftpad(val: any, resultLength = 2, leftpadChar = '0'): string {
    return (String(leftpadChar).repeat(resultLength) + String(val)).slice(
      String(val).length
    );
  }

  openPMadherance() {
    if (this.dashboardCount.adhernce == 0) return;
    const adherenceData = [];
    for (
      let k = new Date(this.HeaderData.StartDate).getMonth();
      k <= new Date(this.HeaderData.EndDate).getMonth();
      k++
    )
      adherenceData.push({ month: k, monthName: this.months[k] });

    this.isMinorChart = false;
    this.isModerateChart = true;
    this.isMajorChart = false;
    let dialogRef = this.dialog.open(this.breakDownDialog, {
      height: 'unset',
      width: '90%',
    });
    let moderateData = [
      { name: 'Value 1', y: 40, machine: 'Test', color: '#0f0fd1' },
    ];
    // this.moderateArr.forEach((element: any) => {
    //   moderateLabel.push('WO ID : ' + element.woID);
    //   moderateData.push({
    //     name: element.woID,
    //     y: parseFloat(element.timeMin),
    //     machine: element.machine,
    //     color: '#0f0fd1'
    //   });
    // });
    let moderateBreakdown: any = {
      chart: {
        type: 'column',
      },
      // colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: this.months,
      },
      yAxis: {
        min: 0,
        max: 100,
        labels: {
          formatter: function () {
            return this.axis.defaultLabelFormatter.call(this) + '%';
          },
        },
      },
      tooltip: {
        formatter(this: any) {
          return `${this.point.series.name} Tasks : ` + this.point.y;
          // return 'Minutes : ' + this.point.y + '<br/>Machine : ' + this.point.machine
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: 'Completed',
          data: this.completedAdherence,
          color: '#2f7ed8',
        },
        {
          name: 'Not Completed',
          data: this.notCompletedAdherence,
          color: '#1aadce',
        },
      ],
      // series: [{
      //   name: 'Moderate Breakdown',
      //   type: 'column',
      //   data: moderateData
      // }]
    };
    let chart = new Chart(moderateBreakdown);
    this.chartModerate = chart;
  }

  openTaskCompleted() {
    if (this.dashboardCount.completed == 0) return;
    if (this.dashboardData && this.dashboardData.length) {
      this.TaskCompletedChartData.AllData = this.dashboardData.filter(
        (rec) => rec.Status == 1
      );
      this.TaskCompletedChartData.UnitData = [
        ...new Set(
          this.TaskCompletedChartData.AllData.map((val) => val.PU_Desc)
        ),
      ];
      this.TaskCompletedChartData.FrequencyData = [
        ...new Set(
          this.TaskCompletedChartData.AllData.map((val) => val.FrequencyName)
        ),
      ];
      this.TaskCompletedChartData.TaskTypeData = [
        ...new Set(
          this.TaskCompletedChartData.AllData.map((val) => val.TaskTypeName)
        ),
      ];
      this.TaskCompletedChartData.MaintenanceTypeData = [
        ...new Set(
          this.TaskCompletedChartData.AllData.map((val) => val.MaintenanceType)
        ),
      ];
    }

    let TaskCompletedUnitLabel: any = [];
    let TaskCompletedUnitData: any = [];

    let TaskCompletedFrequencyLabel: any = [];
    let TaskCompletedFrequencyData: any = [];

    let TaskCompletedTaskTypeLabel: any = [];
    let TaskCompletedTaskTypeData: any = [];

    let TaskCompletedMaintenanceTypeLabel: any = [];
    let TaskCompletedMaintenanceTypeData: any = [];

    this.TaskCompletedChartData.UnitData.forEach((element: any) => {
      const unit = this.TaskCompletedChartData.AllData.filter(
        (rec) => rec.PU_Desc == element
      );
      TaskCompletedUnitData.push({
        name: element,
        y: unit.length,
        // color: '#0f0fd1'
      });
    });
    this.TaskCompletedChartData.FrequencyData.forEach((element: any) => {
      const frequency = this.TaskCompletedChartData.AllData.filter(
        (rec) => rec.FrequencyName == element
      );
      TaskCompletedFrequencyData.push({
        name: element,
        y: frequency.length,
        // color: '#0f0fd1'
      });
    });
    this.TaskCompletedChartData.TaskTypeData.forEach((element: any) => {
      const tasktype = this.TaskCompletedChartData.AllData.filter(
        (rec) => rec.TaskTypeName == element
      );
      TaskCompletedTaskTypeData.push({
        name: element,
        y: tasktype.length,
        // color: '#0f0fd1'
      });
    });
    this.TaskCompletedChartData.MaintenanceTypeData.forEach((element: any) => {
      const maintenancetype = this.TaskCompletedChartData.AllData.filter(
        (rec) => rec.MaintenanceType == element
      );
      TaskCompletedMaintenanceTypeData.push({
        name: element,
        y: maintenancetype.length,
        // color: '#0f0fd1'
      });
    });

    let dialogRef = this.dialog.open(this.TaskCompletedDialog, {
      height: '90vh',
      width: '90%',
    });

    let TaskCompletedUnitChart: any = {
      chart: {
        type: 'column',
      },
      // colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: this.TaskCompletedChartData.UnitData,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`;
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            formatter: function () {
              let ToolTip: any = this;
              return `${ToolTip.point.options.y}`;
            },
          },
        },
        column: {
          pointWidth: 50,
        },
      },
      series: [
        {
          name: 'Units',
          type: 'column',
          colorByPoint: true,
          data: TaskCompletedUnitData,
        },
      ],
    };

    let TaskCompletedFrequencyChart: any = {
      chart: {
        type: 'column',
      },
      // colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: this.TaskCompletedChartData.FrequencyData,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`;
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            formatter: function () {
              let ToolTip: any = this;
              return `${ToolTip.point.options.y}`;
            },
          },
        },
        column: {
          pointWidth: 50,
        },
      },
      series: [
        {
          name: 'Frequency',
          type: 'column',
          colorByPoint: true,
          data: TaskCompletedFrequencyData,
        },
      ],
    };

    let TaskCompletedTaskTypeChart: any = {
      chart: {
        type: 'column',
      },
      // colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: this.TaskCompletedChartData.TaskTypeData,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`;
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            formatter: function () {
              let ToolTip: any = this;
              return `${ToolTip.point.options.y}`;
            },
          },
        },
        column: {
          pointWidth: 50,
        },
      },
      series: [
        {
          name: 'Task Type',
          type: 'column',
          colorByPoint: true,
          data: TaskCompletedTaskTypeData,
        },
      ],
    };

    // let TaskCompletedMaintenanceTypeChart: any = {
    //   chart: {
    //     type: 'column',
    //   },
    //   colors: ['#0f0fd1'],
    //   title: {
    //     text: ''
    //   },
    //   xAxis: {
    //     categories: this.TaskCompletedChartData.MaintenanceTypeData,
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   tooltip: {
    //     formatter(this: any) {
    //       return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`
    //     }
    //   },
    //   plotOptions: {
    //     bar: {
    //       dataLabels: {
    //         enabled: true
    //       }
    //     },
    //     series: {
    //       dataLabels: {
    //         enabled: true,
    //         align: 'center',
    //         formatter: function () {
    //           let ToolTip: any = this;
    //           return `${ToolTip.point.options.y}`;
    //         }
    //       }
    //     },
    //     column: {
    //       poitWidth: 50,
    //     }
    //   },
    //   series: [{
    //     name: 'Maintenance Type',
    //     type: 'column',
    //     data: TaskCompletedMaintenanceTypeData
    //   }]
    // };

    let TaskCompletedMaintenanceTypeChart: any = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>Maintenance Type</b><br/>${this.point.name} : ${this.point.y}`;
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y}',
          },
        },
      },
      series: [
        {
          name: 'Maintenance Type',
          type: 'pie',
          colorByPoint: true,
          data: TaskCompletedMaintenanceTypeData,
        },
      ],
    };

    this.chartTaskCompletedUnit = new Chart(TaskCompletedUnitChart);
    this.chartTaskCompletedFrequency = new Chart(TaskCompletedFrequencyChart);
    this.chartTaskCompletedTaskType = new Chart(TaskCompletedTaskTypeChart);
    this.chartTaskCompletedMaintenanceType = new Chart(
      TaskCompletedMaintenanceTypeChart
    );
  }
  openTaskNotCompleted() {
    if (this.dashboardCount.notCompleted == 0) return;
    if (this.dashboardData && this.dashboardData.length) {
      this.TaskNotCompletedChartData.AllData = this.dashboardData.filter(
        (rec) => rec.Status == 0
      );
      this.TaskNotCompletedChartData.UnitData = [
        ...new Set(
          this.TaskNotCompletedChartData.AllData.map((val) => val.PU_Desc)
        ),
      ];
      this.TaskNotCompletedChartData.FrequencyData = [
        ...new Set(
          this.TaskNotCompletedChartData.AllData.map((val) => val.FrequencyName)
        ),
      ];
      this.TaskNotCompletedChartData.TaskTypeData = [
        ...new Set(
          this.TaskNotCompletedChartData.AllData.map((val) => val.TaskTypeName)
        ),
      ];
      this.TaskNotCompletedChartData.MaintenanceTypeData = [
        ...new Set(
          this.TaskNotCompletedChartData.AllData.map(
            (val) => val.MaintenanceType
          )
        ),
      ];
    }

    let TaskNotCompletedUnitLabel: any = [];
    let TaskNotCompletedUnitData: any = [];

    let TaskNotCompletedFrequencyLabel: any = [];
    let TaskNotCompletedFrequencyData: any = [];

    let TaskNotCompletedTaskTypeLabel: any = [];
    let TaskNotCompletedTaskTypeData: any = [];

    let TaskNotCompletedMaintenanceTypeLabel: any = [];
    let TaskNotCompletedMaintenanceTypeData: any = [];

    this.TaskNotCompletedChartData.UnitData.forEach((element: any) => {
      const unit = this.TaskNotCompletedChartData.AllData.filter(
        (rec) => rec.PU_Desc == element
      );
      TaskNotCompletedUnitData.push({
        name: element,
        y: unit.length,
        // color: '#0f0fd1'
      });
    });
    this.TaskNotCompletedChartData.FrequencyData.forEach((element: any) => {
      const frequency = this.TaskNotCompletedChartData.AllData.filter(
        (rec) => rec.FrequencyName == element
      );
      TaskNotCompletedFrequencyData.push({
        name: element,
        y: frequency.length,
        // color: '#0f0fd1'
      });
    });
    this.TaskNotCompletedChartData.TaskTypeData.forEach((element: any) => {
      const tasktype = this.TaskNotCompletedChartData.AllData.filter(
        (rec) => rec.TaskTypeName == element
      );
      TaskNotCompletedTaskTypeData.push({
        name: element,
        y: tasktype.length,
        // color: '#0f0fd1'
      });
    });
    this.TaskNotCompletedChartData.MaintenanceTypeData.forEach(
      (element: any) => {
        const maintenancetype = this.TaskNotCompletedChartData.AllData.filter(
          (rec) => rec.MaintenanceType == element
        );
        TaskNotCompletedMaintenanceTypeData.push({
          name: element,
          y: maintenancetype.length,
          // color: '#0f0fd1'
        });
      }
    );

    let dialogRef = this.dialog.open(this.TaskNotCompletedDialog, {
      height: '90vh',
      width: '90%',
    });

    let TaskNotCompletedUnitChart: any = {
      chart: {
        type: 'column',
      },
      // colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: this.TaskNotCompletedChartData.UnitData,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`;
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            formatter: function () {
              let ToolTip: any = this;
              return `${ToolTip.point.options.y}`;
            },
          },
        },
        column: {
          // pointWidth: 50,
        },
      },
      series: [
        {
          name: 'Units',
          type: 'column',
          colorByPoint: true,
          data: TaskNotCompletedUnitData,
        },
      ],
    };

    let TaskNotCompletedFrequencyChart: any = {
      chart: {
        type: 'column',
      },
      // colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: this.TaskNotCompletedChartData.FrequencyData,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`;
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            formatter: function () {
              let ToolTip: any = this;
              return `${ToolTip.point.options.y}`;
            },
          },
        },
        column: {
          // pointWidth: 50,
        },
      },
      series: [
        {
          name: 'Frequency',
          type: 'column',
          colorByPoint: true,
          data: TaskNotCompletedFrequencyData,
        },
      ],
    };

    let TaskNotCompletedTaskTypeChart: any = {
      chart: {
        type: 'column',
      },
      // colors: ['#0f0fd1'],
      title: {
        text: '',
      },
      xAxis: {
        categories: this.TaskNotCompletedChartData.TaskTypeData,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`;
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
        series: {
          dataLabels: {
            enabled: true,
            align: 'center',
            formatter: function () {
              let ToolTip: any = this;
              return `${ToolTip.point.options.y}`;
            },
          },
          //
        },
        column: {
          // pointWidth: 10,
          // pointPadding: 10,
          // groupPadding: 10
        },
      },
      series: [
        {
          name: 'Task Type',
          type: 'column',
          colorByPoint: true,
          data: TaskNotCompletedTaskTypeData,
        },
      ],
    };

    // let TaskNotCompletedMaintenanceTypeChart: any = {
    //   chart: {
    //     type: 'column',
    //   },
    //   colors: ['#0f0fd1'],
    //   title: {
    //     text: ''
    //   },
    //   xAxis: {
    //     categories: this.TaskNotCompletedChartData.MaintenanceTypeData,
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   tooltip: {
    //     formatter(this: any) {
    //       return `<b>${this.point.name}</b><br/>Count : ${this.point.y}`
    //     }
    //   },
    //   plotOptions: {
    //     bar: {
    //       dataLabels: {
    //         enabled: true
    //       }
    //     },
    //     series: {
    //       dataLabels: {
    //         enabled: true,
    //         align: 'center',
    //         formatter: function () {
    //           let ToolTip: any = this;
    //           return `${ToolTip.point.options.y}`;
    //         }
    //       }
    //     },
    //     column: {
    //       poitWidth: 50,
    //     }
    //   },
    //   series: [{
    //     name: 'Maintenance Type',
    //     type: 'column',
    //     data: TaskNotCompletedMaintenanceTypeData
    //   }]
    // };

    let TaskNotCompletedMaintenanceTypeChart: any = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        formatter(this: any) {
          return `<b>Maintenance Type</b><br/>${this.point.name} : ${this.point.y}`;
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y}',
          },
        },
      },
      series: [
        {
          name: 'Maintenance Type',
          type: 'pie',
          colorByPoint: true,
          data: TaskNotCompletedMaintenanceTypeData,
        },
      ],
    };

    this.chartTaskNotCompletedUnit = new Chart(TaskNotCompletedUnitChart);
    this.chartTaskNotCompletedFrequency = new Chart(
      TaskNotCompletedFrequencyChart
    );
    this.chartTaskNotCompletedTaskType = new Chart(
      TaskNotCompletedTaskTypeChart
    );
    this.chartTaskNotCompletedMaintenanceType = new Chart(
      TaskNotCompletedMaintenanceTypeChart
    );
  }

  openElectricalTask() { }
  openMechanicalTask() { }
  openOperatorTask() { }
  openTBMCompletion() { }

  openCBMCompletion() { }
  openDefectsFound() { }
  getPMadherance() {
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Total Breakdowns',
      },
      colors: ['#ff914d'],
      xAxis: {
        categories: ['Total BD', 'Minor BD', 'Moderate BD', 'Major BD'],
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [{ showInLegend: false, data: [49.9, 71.5, 106, 4.4] }],
    } as any;
    let chart = new Chart(this.options);
    this.totalBreakdowns = chart;
    this.options = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
      },
      title: {
        text: 'BD Category',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
      },
      accessibility: {
        point: {
          valueSuffix: '%',
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          },
        },
      },
      series: [
        {
          name: 'Brands',
          colorByPoint: true,
          data: [
            {
              name: 'Utillites',
              y: 10.85,
            },
            {
              name: 'Forklift',
              y: 4.67,
            },
            {
              name: 'Electrical',
              y: 4.18,
            },
            {
              name: 'Mechanical',
              y: 1.64,
            },
          ],
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.bdCategory = chart;
    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Major BD Machine Level',
      },
      xAxis: {
        categories: [
          'January',
          'Feburary',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'Decmber',
        ],
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },

        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color:
              // theme
              (Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              'gray',
          },
        },
      },
      legend: {
        align: 'right',
        x: -30,
        verticalAlign: 'top',
        y: 25,
        floating: true,
        backgroundColor:
          Highcharts.defaultOptions.legend.backgroundColor || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false,
      },
      tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
          },
        },
      },
      series: [
        {
          showInLegend: false,
          color: '#1212d1',
          data: [2, 2, 3, 2, 1, 3, 2, 1, 3, 15],
        },
        {
          color: '#008037',
          showInLegend: false,
          data: [2, 2, 3, 2, 1, 3, 2, 1, 3, 5],
        },
        {
          showInLegend: false,
          color: '#6ce5e8',
          data: [3, 4, 4, 2, 5, 1, 3, 2, 1, 3],
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.majorBDMachineLevel = chart;

    this.options = {
      chart: {
        type: 'column',
      },
      title: {
        text: 'Major BD Sub Assembly Level',
      },
      subtitle: {
        text: '',
      },
      xAxis: {
        categories: [
          'Infeed',
          'Feeder1',
          'Pump',
          'PU1',
          'PU2',
          '3Knife',
          'Stecker',
          'Feeder2',
          'UNIT 3',
          'Splicer Unit',
          'Reel Stand',
          'Dryer',
        ],
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} mm</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [
        {
          color: '#6ce5e8',
          showInLegend: false,
          data: [
            49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1,
            95.6, 54.4,
          ],
        },
        {
          color: '#41b8d5',
          showInLegend: false,
          data: [
            83.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0, 104.3, 91.2, 83.5,
            106.6, 92.3,
          ],
        },
      ],
    } as any;
    chart = new Chart(this.options);
    this.majorBDSubAssemblyLevel = chart;
  }

  /// AG Grid
  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.autoSizeAllColumns();
  }

  excelExport() {
    const allColumnIds = this.gridColumnApi
      .getAllColumns()
      .map((col) => col.getColId())
      .filter((colId) => colId !== 'Action'); // exclude 'action' column

    this.gridApi.exportDataAsExcel({
      columnKeys: allColumnIds,
    });
  }
  csvExport() {
    const allColumnIds = this.gridColumnApi
      .getAllColumns()
      .map((col) => col.getColId())
      .filter((colId) => colId !== 'Action'); // exclude 'action' column

    this.gridApi.exportDataAsCsv({
      columnKeys: allColumnIds,
    });
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
    this.technicianTaskId = params.data.TechnicianTaskId;
    this.ButtonType = '';
    const taskId = params.data.TaskId;
    if (col === 'Action') {
      this.ButtonType = params.event.target.textContent;
      if (this.ButtonType === 'list_alt') {
        const checklistIds = params.data.ChecklistIds;
        const unitId = params.data.UnitID;
        if (
          this.technicianTaskId != null &&
          checklistIds != null &&
          unitId != null
        ) {
          this.onClickCheckList(this.technicianTaskId, checklistIds, unitId);
        } else {
          this.toaster.warning('Checklist Not created against this Task');
        }
      } else if (this.ButtonType === 'format_list_bulleted') {
        this.onClickParameter();
      } else if (this.ButtonType === 'fact_check') {
        this.loadAllWorkLogs(params?.data?.WorkLog);
      } else if (this.ButtonType === '') {
        this.onClickSubtaskHistory();
      }
    }
    if (col == 'UploadFile') {
      this.openEditFilesModal(this.technicianTaskId);
      //   this.imageZoomModal(params.value, 'initialImage');
      // else this.imageZoomModal('assets/images/no-image.png', 'initialImage');
    }
  }
  openEditFilesModal(file: any): void {
    const taskFiles = this.previewArray.filter(
      (f) => f.technicianTaskId === file
    );
    this.previewerData = new MatTableDataSource(taskFiles);

    // Attach paginator if needed
    setTimeout(() => {
      if (this.previewerData && this.paginator) {
        this.previewerData.paginator = this.paginator;
      }
    });

    this.dialog.open(this.previewModal, { height: 'auto', width: '90%' });
  }
  ViewFile(path: any) {
    if (this.isBase64(path)) {
      path = this.decodeBase64(path);
    }
    this.fileType = this.getFileType(path);
    switch (this.fileType) {
      case 'doc':
        this.doc = path;
        break;
      case 'image':
        this.images = [path];
        break;
      case 'video':
        this.viewDocument = this.sanitizer.bypassSecurityTrustUrl(path);
        break;
      default:
        this.viewDocument = this.sanitizer.bypassSecurityTrustUrl(path);
        break;
    }

    this.dialogRef = this.dialog.open(this.viewdocument, {
      height: 'auto',
      width: '100vh',
    });
  }
  isBase64(str: string): boolean {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }
  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  decodeBase64(base64: string): string {
    return `data:;base64,${base64}`;
  }
  toggleAllSelectionLine() {
    if (this.allSelectedLine.selected) {
      const allLines = this.filteredLines.map((x) => x.PL_Id);
      this.HeaderForm.controls.Line.patchValue(['ALL', ...allLines]);
    } else {
      this.HeaderForm.controls.Line.patchValue([]);
    }
  }

  tosslePerOneLine() {
    if (this.allSelectedLine.selected) {
      this.allSelectedLine.deselect();
      return;
    }
    if (
      this.HeaderForm.controls.Line.value.length == this.filteredLines.length
    ) {
      const allLines = this.filteredLines.map((x) => x.PL_Id);
      this.HeaderForm.controls.Line.patchValue(['ALL', ...allLines]);
    }
  }

  onClickCheckList(taskId: number, checklistIds: string, unitId: number): void {
    this.dialog.open(this.checklistHistory, {
      height: 'auto',
      maxHeight: '90vh',
      width: '80%',
    });
    this.getChecklistHistory(taskId, checklistIds, unitId);
  }

  onClickParameter(): void {
    if (this.technicianTaskId) {
      this.spinner.show();
      this.technicianService
        .getTechnicianTaskParametertargetBytechnicianId(this.technicianTaskId)
        .subscribe(
          (response) => {
            this.spinner.hide();
            this.parameterrowData = response;
          },
          (error) => {
            this.spinner.hide();
            this.toaster.error('Error', error.message);
          }
        );
    }
    this.dialog.open(this.parameterHistory, {
      height: 'auto',
      maxHeight: '90vh',
      width: '55%',
    });
  }
  onClickSubtaskHistory(): void {
    const data: any = {
      isAssignedToMainTask: true,
      responsibleId: this.userSession?.userCode,
      technicianTaskId: this.technicianTaskId,
    };

    this.technicianService.GetSubTaskWorkOrdersByTaskOrWOID(data).subscribe(
      (subtaskData: any) => {
        this.subTaskData = subtaskData;
      },
      (error) => { }
    );
    this.dialog.open(this.SubtaskHistory, {
      height: 'auto',
      maxHeight: '90vh',
      width: '55%',
    });
  }

  getParameterHistory(): void {
    this.parameterrowData = [
      { parameter: 'Waste Count', target: 12, actual: 0 },
      { parameter: 'Net Production', target: 15, actual: 0 },
      { parameter: 'Rewind Tension (N)', target: 20, actual: 0 },
      { parameter: 'Unwind Tension (N)', target: 10, actual: 0 },
    ];
  }

  getChecklistHistory(
    taskid: number,
    checklistIds: string,
    unitId: number
  ): void {
    this.checklistrowData = [];
    this.spinner.show();
    const payloadForExecutionIds = {
      PlantCode: this.plantSession?.plantCode,
      ChecklistIds: checklistIds,
      TaskId: taskid,
    };
    this.PrevConfigurationService.getQualityCheckListExecPMData(
      payloadForExecutionIds
    ).subscribe({
      next: (data) => {
        this.spinner.hide();
        if (data.length > 0) {
          const executionIds = data
            .map((item) => item.ExecutionId || 0)
            .join(',');
          this.spinner.show();
          const payloadForExecutionDetails = {
            ChecklistId: checklistIds,
            UnitId: unitId,
            ExecutionId: executionIds,
            TaskId: taskid,
          };
          this.PrevConfigurationService.getQualityChecklistPMDetailsData(
            payloadForExecutionDetails
          ).subscribe({
            next: (res) => {
              this.spinner.hide();
              this.checklistrowData = res;
              if (this.checklistrowData) {
                this.prepareTabs();
              }
            },
            error: (error) => {
              this.spinner.hide();
              this.toaster.error('Error', error.ErrorMessage);
            },
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      },
    });
    // this.technicianService.getChecklistByGroupsAndTaskId(taskid, techId).subscribe(
    //   (res: any) => {
    //     this.spinner.hide();
    //     res.forEach((item: any) => {
    //       if (item.ItemType === 3) {
    //         item.Execution_Result = item.Execution_Date;
    //       } else if (item.ItemType === 4) {
    //         item.Execution_Result = item.Execution_FilePath;
    //       }
    //     });

    //     this.checklistrowData = res;
    //   },
    //   (error: any) => {
    //     this.spinner.hide();
    //     this.toaster.error('Error', error.message);
    //   },
    // );
  }

  prepareTabs() {
    this.tabs = [];
    const dataObj = this.checklistrowData;
    const tabMap: { [listName: string]: any[] } = {};

    Object.values(dataObj).forEach((entries: any[]) => {
      entries.forEach((item) => {
        const exec =
          item.Execution && Object.keys(item.Execution).length
            ? item.Execution
            : item;
        const row = {
          ...exec,
          areaName: item.areaName,
          itemGroup: item.itemGroup,
          itemName: item.itemName,
          standard: item.standard,
          minValue: item.minValue,
          maxValue: item.maxValue,
          goodExampleImage: item.goodExampleImage,
          badExampleImage: item.badExampleImage,
        };

        const listName = item.listName;
        if (!tabMap[listName]) tabMap[listName] = [];
        tabMap[listName].push(row);
      });
    });

    this.tabs = Object.keys(tabMap).map((key) => ({
      name: key,
      data: tabMap[key],
    }));
  }

  loadAllWorkLogs(workLogDataJson: any): void {
    const parsedData =
      typeof workLogDataJson === 'string'
        ? JSON.parse(workLogDataJson)
        : workLogDataJson;
    if (
      Array.isArray(parsedData) &&
      parsedData.every((item) => item && typeof item.title === 'string')
    ) {
      this.workLogs = parsedData;
    } else {
      this.workLogs = [];
      console.warn('Invalid work log format.');
    }
    this.dialog.open(this.WorkLogDetails, {
      height: 'auto',
      maxHeight: '90vh',
      width: '55%',
    });
  }

  onCellClicked(params: any) {
    if (params.colDef.field === 'GoodExampleImageName') {
      const fileName = params.value?.split('/')?.pop();
      this.fileType = this.getFileType(fileName);
      this.images = [];
      this.displayMaximizable = true;
      const newFileName =
        environment.blobStorageUrl + params.data.GoodExampleImageName;
      switch (this.fileType) {
        case 'image':
          this.images?.push(newFileName);
          this.displayMaximizable = true;
          break;
        case 'doc':
          this.doc = newFileName;
          break;
        case 'unknown':
          this.displayMaximizable = false;
          this.toaster.error('Error', 'Unknown Type');
          break;
      }
    }
    if (params.colDef.field === 'BadExampleImageName') {
      const fileName = params.value?.split('/')?.pop();
      this.fileType = this.getFileType(fileName);
      this.images = [];
      this.displayMaximizable = true;
      const newFileName =
        environment.blobStorageUrl + params.data.BadExampleImageName;
      switch (this.fileType) {
        case 'image':
          this.images?.push(newFileName);
          this.displayMaximizable = true;
          break;
        case 'doc':
          this.doc = newFileName;
          break;
        default:
          this.displayMaximizable = false;
          this.toaster.error('Error', 'Unknown Type');
          break;
      }
    }
    if (params.colDef.field === 'catType') {
      const fileName = params.value?.split('/')?.pop();
      this.fileType = this.getFileType(fileName);
      this.images = [];
      this.displayMaximizable = true;
      const newFileName = params.data.catType;
      switch (this.fileType) {
        case 'image':
          this.images?.push(newFileName);
          this.displayMaximizable = true;
          break;
        case 'doc':
          this.doc = newFileName;
          break;
        default:
          this.displayMaximizable = false;
          // this.toaster.error('Error', 'Unknown Type');
          break;
      }
    }
    this.Id = params.data.Id;
    const col = params.colDef.field;
    if (col === 'action') {
      this.ButtonType = params.event.target.textContent;
    }
  }
  getFileType(fileName) {
    if (fileName.match(/\.(jpeg|jpg|gif|png|tiff|bmp|webp|eps|svg|jfif)$/)) {
      return 'image';
    } else if (
      fileName.match(
        /\.(doc|docx|xls|xlsx|ppt|pptx|pdf|txt|csv|rtf|odt|ods|odp)$/
      )
    ) {
      return 'doc';
    } else {
      return 'unknown';
    }
  }
}
